import { render, staticRenderFns } from "./NuvaCoinsValidate.vue?vue&type=template&id=144bd156&scoped=true"
import script from "./NuvaCoinsValidate.vue?vue&type=script&lang=js"
export * from "./NuvaCoinsValidate.vue?vue&type=script&lang=js"
import style0 from "./NuvaCoinsValidate.vue?vue&type=style&index=0&id=144bd156&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144bd156",
  null
  
)

export default component.exports